import { makeStyles } from '@material-ui/styles';

const CONTROL_BAR_HEIGHT = 70;

export default makeStyles(theme => ({
  container: {
    height: '100%',
    width: '100%',
    overflow: 'hidden',
  },
  survey: {
    padding: theme.spacing(4),
    height: '100%',
    overflow: 'scroll',
    [theme.breakpoints.up('mobile')]: {
      height: `unset`,
      minHeight: 360,
      overflow: 'unset',
    },
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    transform: 'translateX(0%)',
    '-webkit-transform': 'translateX(0%)',
    opacity: 1,
    transition: 'transform 300ms, opacity 300ms',
    '-webkit-transition': 'transform 300ms, opacity 300ms',
  },
  surveyEntering: {
    padding: theme.spacing(4),
    height: '100%',
    overflow: 'scroll',
    [theme.breakpoints.up('mobile')]: {
      height: 'unset',
      minHeight: 360,
      overflow: 'unset',
    },
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    transform: 'translateX(100%)',
    '-webkit-transform': 'translateX(100%)',
    opacity: 0,
  },
  surveyWithBar: {
    height: `calc(100% - ${CONTROL_BAR_HEIGHT}px)`,
    [theme.breakpoints.up('mobile')]: {
      height: `unset`,
    },
  },
  surveyNoBar: {
    height: '100%',
    [theme.breakpoints.up('mobile')]: {
      height: `unset`,
    },
  },
  noProducts: {
    height: '100%',
    [theme.breakpoints.up('mobile')]: {
      height: `unset`,
    },
  },

  bottomBar: {
    width: '100%',
    display: 'flex',
    marginTop: 0,
    height: CONTROL_BAR_HEIGHT,
    padding: theme.spacing(2),
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    borderTop: [1, 'solid', theme.palette.colors.border],
    [theme.breakpoints.up('mobile')]: {
      marginTop: theme.spacing(2),
      height: 'unset',
      minHeight: 105,
      padding: 0,
      paddingTop: theme.spacing(7),
      justifyContent: 'flex-start',
      borderTop: [1, 'dotted', theme.palette.colors.border],
    },
  },
  progress: {
    [theme.breakpoints.up('mobile')]: {
      marginRight: theme.spacing(3),
    },
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurvey/useStyles.js